import React from 'react';

const Thanks = () => {
    return (
        <>
            <div className="Thanks">
                <div className="form">
                    <div className="form__left">
                        <h1 className="form__left-txt1 text-jost-sb-50-wt">Contact us below</h1>
                        <p className="form__left-para text-ops-rg-16-wt">Lorem ipsum dolor sit amet, consectetur
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin eu mattis velit.
                            Donec dictum leo vel fermentum placerat. Null bibendum blandit. Praesent
                            eu consequat dictum leovel. Aenean consectetur sit amet sem non maximus.
                            Praesent dictum, odio non posuere scelerisque, diam augue sagittis arcu,
                            vitae egestas tortor ligula ut arcu sit amet sem non. Aenean consectetur
                            sit amet sem non maximus. Praesent dictum, odio non.</p>
                    </div>
                    <div className="form__right">
                        <div className="form__right__box">
                        <h1 className="form__left-txt1 text-jost-sb-50">Thank you!</h1>
                        <p className="text-ops-rg-16">We’ve received your message and we’ll get back to you within 24
                            hours.</p>
                        <a href="/" target="_self" className="res-btn-primary">OK, THANKS</a>
                        </div>
                    </div>
                </div>
                    <div className="social">
                        <div className="social__media">
                            <div className="social__media__tweet">
                                <div className="social__media__tweet-head">
                                    <img
                                        src={require("../../assets/images/main/social_networking/tweet.svg").default}
                                        alt=""/>
                                    <span className="text-jost-sb-22-wt">@Timelytee</span>
                                </div>
                                <p className="social__media__tweet-para text-ops-rg-16-wt">Lorem ipsum dolor sit amet,
                                    consectetur adipiscing
                                    elit. Etiam
                                    vitae
                                    cursus leo, quis semper erat. Quisque sit amet semper massa,
                                </p>
                                <a href="https://linklooks.likethis"
                                   className="social__media__tweet-link text-ops-rg-16-lg">https://linklooks.likethis</a>
                            </div>
                            <div className="social__media__tweet">
                                <div className="social__media__tweet-head">
                                    <img
                                        src={require("../../assets/images/main/social_networking/tweet.svg").default}
                                        alt=""/>
                                    <span className="text-jost-sb-22-wt">@Timelytee</span>
                                </div>
                                <p className="social__media__tweet-para text-ops-rg-16-wt">Lorem ipsum dolor sit amet,
                                    consectetur adipiscing
                                    elit. Etiam
                                    vitae
                                    cursus leo, quis semper erat. Quisque sit amet semper massa,
                                </p>
                                <a href="https://linklooks.likethis"
                                   className="social__media__tweet-link text-ops-rg-16-lg">https://linklooks.likethis</a>
                            </div>
                            <div className="social__media__btn">
                                <button>
                                    <img
                                        src={require("../../assets/images/main/social_networking/btn/social_btn_left.svg").default}
                                        alt=""/>
                                </button>
                                <button>
                                    <img
                                        src={require("../../assets/images/main/social_networking/btn/social_btn_right.svg").default}
                                        alt=""/>
                                </button>
                            </div>
                        </div>
                        <div className="social__insta">
                            <a href="https://yourlink.com">
                                <img
                                    src={require("../../assets/images/main/social_networking/insta/insta_1.svg").default}
                                    alt=""/>
                            </a>
                            <a href="https://yourlink.com">
                                <img
                                    src={require("../../assets/images/main/social_networking/insta/insta_2.svg").default}
                                    alt=""/>
                            </a>
                            <a href="https://yourlink.com">
                                <img
                                    src={require("../../assets/images/main/social_networking/insta/insta_3.svg").default}
                                    alt=""/>
                            </a>
                            <a href="https://yourlink.com">
                                <img
                                    src={require("../../assets/images/main/social_networking/insta/insta_6.svg").default}
                                    alt=""/>
                            </a>
                            <a href="https://yourlink.com">
                                <img
                                    src={require("../../assets/images/main/social_networking/insta/insta_1.svg").default}
                                    alt=""/>
                            </a>
                            <a href="https://yourlink.com">
                                <img
                                    src={require("../../assets/images/main/social_networking/insta/insta_2.svg").default}
                                    alt=""/>
                            </a>
                        </div>
                    </div>
                </div>
            </>
    );
};

export default Thanks;
